




















import { Vue, Component, Prop } from "vue-property-decorator";
import { MDialog, MMessage } from "@ulaval/modul-components";
import store, { modules } from "../store";

@Component({
  components: {
    MDialog,
    MMessage,
  },
})
export default class FenetreConfirmationAnnluer extends Vue {
  @Prop({ type: Function, required: true })
  private surOk!: () => Promise<void>;

  get afficherFenetreConfirmation(): boolean {
    return store.state.trainProgression.surAnnuler;
  }

  private cacherAnnulation(): void {
    store.commit(modules.trainProgression.mutations.cacherAnnulation.name);
  }
}
